export default "__VITE_ASSET__gbyE_Amm__"